import { render, staticRenderFns } from "./CreateOrderShipmentDialog.vue?vue&type=template&id=6990e07d&"
import script from "./CreateOrderShipmentDialog.vue?vue&type=script&lang=js&"
export * from "./CreateOrderShipmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderShipmentDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports